import React from "react";

import FooterTwo from "../components/Footers/FooterTwo";
import HeaderTwo from "../components/Headers/HeaderTwo";
import ScrollTop from "../components/ScrollTop/ScrollTop";

const Layout = ({ children, header = 1, footer, className, mainClassName }) => {
  return (
    <>
      {/* <Preloader /> */}
      {/* <ScrollTop /> */}

      <div className={className}>
        {header === 1 && <HeaderTwo />}
        {header === 2 && <HeaderTwo />}

        <main className={mainClassName}>{children}</main>

       <FooterTwo />
        {/* {footer === 2 && <FooterTwo />}
        {footer === 3 && <FooterThree />} */}
      </div>
    </>
  );
};

export default Layout;
